module.exports = __webpack_public_path__ + "static/media/IMG_6190_2.3437339c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6190_2.jpg
// module id = 209
// module chunks = 0